import { useTranslation } from 'react-i18next';
import ChatStyles from './Chat.module.css';

const Header = ({ acceptedUserSearch, setAcceptedUserSearch }) => {
  const { t } = useTranslation();
  return (
    <div className={ChatStyles.convListHeader}>
      <div className={ChatStyles.convListTitleRow}>
        <span className={ChatStyles.convListTitle}>{t('screens.chat.messagesTitle')}</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span className={ChatStyles.encBadge}>
            <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5'>
              <rect x='3' y='11' width='18' height='11' rx='2' />
              <path d='M7 11V7a5 5 0 0 1 10 0v4' />
            </svg>
            {t('screens.chat.e2eBadge')}
          </span>
        </div>
      </div>

      {/* Search */}
      <div className={ChatStyles.convSearch}>
        <svg className={ChatStyles.convSearchIcon} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
          <circle cx='11' cy='11' r='8' />
          <line x1='21' y1='21' x2='16.65' y2='16.65' />
        </svg>
        <input
          className={ChatStyles.convSearchInput}
          placeholder={t('screens.chat.searchConversations')}
          value={acceptedUserSearch}
          onChange={e => setAcceptedUserSearch(e.target.value)}
        />
      </div>
    </div>
  );
};

export default Header;
